import React, {Fragment, useState, useEffect} from 'react'
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { Cabecera } from '../components/Cabecera';
import { Footer } from '../components/Footer';
export const Activarcuenta = (props) => {
   
    const history = useHistory();
    const [textoInfo, setTextoInfo] = useState(false)

   

    const fetchActivarCuenta = async () => {
        let dataFormEventos = {  
            "claveUsuario": window.location.search.split('code=')[1]
         }
        
        let axiosConfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },  
        };
        axios.post(`${process.env.REACT_APP_URL_API}auth/VerificarRegistro`, dataFormEventos, axiosConfig)
        .then((res) => {
        
            history.push(`/cuenta-activada/ok`)
        })
        .catch((err) => {
            setTextoInfo('Cod invalido no se ha podido acgivar la cuenta')
        }) 
    }

    useEffect(() => {
        fetchActivarCuenta();
    },[])

    if(!textoInfo) { return(<div></div>) } 
    return(
        <Fragment>
        <Cabecera imagen={false} top={false} removeAuth={props.removeAuth} />
        <section className="py-5">
            <div className="container">
            
            <div className="row">
                <div className="col-md-12">
                  
                
                </div>
            </div>
            </div> 
        </section>
        <Footer />
    </Fragment>
    )

}